<template>
    <div class="wrap">
        <!-- 헤더 -->
        <main-header></main-header>

        <!-- 메인 -->
        <main class="main">
            <slot />
        </main>

        <!-- 푸터 -->
        <main-footer><!-- 기업정보 --></main-footer>
    </div>
</template>

<script>
import MainHeader from "@/components/client/inc/main-header.vue";
import MainFooter from "@/components/client/inc/main-footer.vue";
import { mapActions } from 'vuex';
export default {
    props: {
        isMain: { type: Boolean, default: true },
    },
    components: {
        MainHeader,
        MainFooter,
    },
    computed: {
        store() {
            return this.$store.state;
        },
    },
    methods: {
        ...mapActions(["getAreas"]),
        init() {
            this.getAreas();
        },
    },
    mounted() {
        this.init();
    },
};
</script>
